import { RouteProps, useSearchParams, Link } from 'react-router-dom';
import { FunctionComponent, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { PageLayout } from '../../components';
import styles from './styles.module.scss';
import classNames from 'classnames';

const Unsubscribe: FunctionComponent<RouteProps> = () => {
	const [searchParams] = useSearchParams();
	const [email, setEmail] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [message, setMessage] = useState<{ type: 'success' | 'error' | null, text: string }>({ type: null, text: '' });

	useEffect(() => {
		const emailParam = searchParams.get('email');
		if (emailParam) {
			setEmail(emailParam);
		}
	}, [searchParams]);

	const handleUnsubscribe = async () => {
		if (!email) {
			setMessage({ type: 'error', text: 'Te rugăm să introduci o adresă de email.' });
			return;
		}

		// Basic email validation
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			setMessage({ type: 'error', text: 'Te rugăm să introduci o adresă de email validă.' });
			return;
		}

		setIsLoading(true);
		setMessage({ type: null, text: '' });

		try {
			await axios.post(`${API_BASE_URL}/api/unsubscribe`, { email });
			setMessage({ type: 'success', text: 'Te-ai dezabonat cu succes de la newsletter.' });
		} catch (error) {
			console.error(error);
			setMessage({
				type: 'error',
				text: 'A apărut o eroare la dezabonare. Te rugăm să încerci din nou sau să ne contactezi.'
			});
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<PageLayout showTitle={false}>
			<div className={styles.container}>
				<h1 className={styles.title}>Dezabonare Newsletter</h1>

				<p className={styles.description}>
					Dacă dorești să nu mai primești noutăți despre Maneliada, introdu adresa ta de email mai jos.
				</p>

				<div className={styles.inputWrapper}>
					<input
						type="email"
						className={styles.inputBase}
						placeholder="Adresa ta de email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						disabled={isLoading}
					/>

					<button
						className={styles.actionButton}
						onClick={handleUnsubscribe}
						disabled={isLoading}
					>
						{isLoading ? 'Se procesează...' : 'Vreau să mă dezabonez'}
					</button>
				</div>

				{message.text && (
					<div className={classNames(styles.message, {
						[styles.error]: message.type === 'error',
						[styles.success]: message.type === 'success'
					})}>
						{message.text}
					</div>
				)}

				<p className={styles.description} style={{ marginTop: '30px', fontSize: '0.9rem', opacity: 0.8 }}>
					Dacă întâmpini probleme, ne poți contacta la{' '}
					<a href="mailto:contact@maneliada.ro">contact@maneliada.ro</a>.
				</p>

				<div className={styles.buttonWrapper}>
					<Link to="/" style={{ color: '#efa43b', textDecoration: 'none', border: '1px solid #efa43b', padding: '10px 20px', borderRadius: '15px' }}>
						Înapoi la pagina principală
					</Link>
				</div>
			</div>
		</PageLayout>
	);
};

export default Unsubscribe;
